"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPreviousOrder = exports.fetchOrderHistory = exports.forgotPassword = exports.login = exports.createAccount = exports.deleteAccount = exports.updateAccount = exports.fetchResendVerificationEmail = exports.fetchAccount = exports.changePassword = void 0;

var _tslib = require("tslib");

var _api = require("../api");

var _types = require("./types");

var changePassword = function changePassword(request) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.ChangePassword, request).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.changePassword = changePassword;

var fetchAccount = function fetchAccount() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get(_types.Versions.Account + "/" + _types.Endpoints.Account).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchAccount = fetchAccount;

var fetchResendVerificationEmail = function fetchResendVerificationEmail() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get(_types.Versions.ResendVerificationEmail + "/" + _types.Endpoints.ResendVerificationEmail).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchResendVerificationEmail = fetchResendVerificationEmail;

var updateAccount = function updateAccount(account) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.UpdateAccount, account).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.updateAccount = updateAccount;

var deleteAccount = function deleteAccount() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api["delete"]("" + _types.Endpoints.DeleteAccount).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.deleteAccount = deleteAccount;

var createAccount = function createAccount(request) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.CreateAccount, request).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.createAccount = createAccount;

var login = function login(_a) {
  var username = _a.username,
      password = _a.password,
      fingerprintID = _a.fingerprintID,
      recaptchaToken = _a.recaptchaToken;
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_b) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.Login, {
        username: username,
        password: password,
        fingerprintID: fingerprintID,
        recaptchaToken: recaptchaToken
      }).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.login = login;

var forgotPassword = function forgotPassword(_a) {
  var emailAddress = _a.emailAddress;
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_b) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.ForgotPassword, {
        emailAddress: emailAddress
      }).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.forgotPassword = forgotPassword;

var fetchOrderHistory = function fetchOrderHistory() {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get(_types.Endpoints.OrderHistory).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchOrderHistory = fetchOrderHistory;

var fetchPreviousOrder = function fetchPreviousOrder(request) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.PreviousOrder, request).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchPreviousOrder = fetchPreviousOrder;